import * as msal from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: '64b5d8a3-8c51-43b8-be02-fd08a8feb24e',
        authority: 'https://login.microsoftonline.com/c31fa6a2-1997-4f5c-a6bf-bfa4b0f15003',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export default msalInstance;
